@if (isVisible) {
  <div class="dynamicPlacemark"
    [style.top.px]="top"
    [style.left.px]="left"
    [style.transform]="scale"
    >
    <div class="space"></div>
    @if (noContentToDisplay) {
      <div class="no-data-message">
        No data is available
      </div>
    }
    @if (!noContentToDisplay) {
      <div class="piechartContainer" (mouseleave)="mouseLeave()" (mouseenter)="mouseEnter()">
        @if (pieConf.showChartName) {
          <div class="piechartTitle" #chartName insTooltip [cfg]="getToolTipConf(chartName, pieConf.chartName)">{{pieConf.chartName}}</div>
        }
        @if (pieData.length > 0) {
          <div class="piechart">
            <div class="" [style.width.px]="pieConf.pieDiameter" [style.height.px]="pieConf.pieDiameter">
              @if (showPieChart) {
                <google-chart [type]="'PieChart'" [data]="pieData" [columns]="names" [options]="pieChartOptions" [width]="pieConf.pieDiameter" [height]="pieConf.pieDiameter"></google-chart>
              }
            </div>
            <perfect-scrollbar class="scrollbar" [style.height.px]="+pieConf.pieDiameter">
              @if (pieConf.showLegend) {
                <div class="piechartLegend" [style.visibility]="showPieChart ? 'visible': 'hidden' ">
                  @for (item of pieData; track item; let i = $index) {
                    <div class="legend">
                      <div class="color" [style.backgroundColor]="pieChartOptions.slices[i].color"></div>
                      <div class="variableName" #variableName insTooltip [cfg]="getToolTipConf(variableName, item[0])">{{item[0]}}</div>
                    </div>
                  }
                </div>
              }
            </perfect-scrollbar>
          </div>
        }
      </div>
    }
  </div>
}